<template>
    <div>
        <div class="notifications">
            <TransitionGroup name="fade">
                <Notification
                    v-for="notification in notifications"
                    v-bind="notification"
                    :key="notification.timestamp.getTime()"
                    :click-handler="notification.onClick"
                    @close="removeNotification" />
            </TransitionGroup>
        </div>
    </div>
</template>
<script>
import Notification from './Notification.vue';

export default {
    components: {
        Notification
    },
    props: {
        transitionDuration: {
            type: Number,
            default: 200
        },
        overlap: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        notifications() {
            return this.$notifications.state;
        }
    },
    methods: {
        removeNotification(timestamp) {
            this.$notifications.removeNotification(timestamp);
        }
    },
    created() {
        this.$notifications.settings.overlap = this.overlap;
    },
    watch: {
        overlap: function (newVal) {
            this.$notifications.settings.overlap = newVal;
        }
    }
};
</script>
<style>
.fade-move,
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-active,
.fade-leave-active {
    opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-15px);
}
</style>
